import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import makeArray from 'webapp/helpers/make-array';
import visibleCheckContainer from 'webapp/modifiers/visible-check-container';
import MetricLibraryGridComponent from 'webapp/components/metric-library/grid/index';
import MetricLibrarySourceGridItemComponent from 'webapp/components/metric-library/source/grid-item';

import FilterSortMetricLibraryMainIntegrations from 'webapp/models-custom/filter-sort/metric-library-main-integrations';
import type SourceType from 'webapp/models-custom/source-type';

interface Args {
	connectedIntegrations: SourceType[];
}

export default class MetricLibraryConnectedIntegrationsComponent extends Component<Args> {
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	filterSort;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.filterSort = new FilterSortMetricLibraryMainIntegrations({
			getAllItems: () => {
				return this.integrations;
			},
		});
	}

	get integrations() {
		return this.args.connectedIntegrations;
	}
	<template>
		<MetricLibraryGridComponent
			@filterSort={{this.filterSort}}
			@title="Connected integrations"
			@animationProperty="id"
			@hideCountBadge={{true}}
			as |visibleItems settings|
		>
			<ul class="flex-ct flex-ct--size-source" {{visibleCheckContainer}}>
				{{#each visibleItems as |model|}}
					<MetricLibrarySourceGridItemComponent @model={{model}} />
				{{/each}}

				{{! adding (max-in-line - 1) fake items so the incomplete last row items are not stretched too much }}
				{{#each (makeArray length=settings.itemsPerRow)}}
					<li class="flex-item flex-item--fake"></li>
				{{/each}}
			</ul>
		</MetricLibraryGridComponent>
	</template>
}
